import { useMutation, useQueryClient } from '@tanstack/react-query';
import { L2_VALUES } from 'Deer/constants/routes';
import { sendRequest } from 'api/sendRequest';
import { useToast } from 'components/hooks/useToast';
import { useHistory } from 'react-router-dom';
import { useReviewCreationData } from 'reducers/reviewCreationSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { MODULE_KEYS1 } from 'constants/ProjectConstants';
import { endpoints } from 'constants/endpoints';
import { goToDeerModuleSettingsPage, goToModuleSettingsPage } from 'constants/helper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

const saveCompleteFormApi = ({ reviewCycleId }) => {
  const url = endpoints.reviews.reviewFormV1;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: { review_cycle_id: reviewCycleId },
  });
};

export const useSaveReviewCycle = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const history = useHistory();

  const { reviewCycleId } = useReviewCreationData();

  return useMutation({
    mutationFn: () =>
      saveCompleteFormApi({
        reviewCycleId,
      }),
    onSuccess: () => {
      queryClient.removeQueries([REACT_QUERY_KEYS.ReviewSections]);

      if (checkNewNavEnabled()) {
        goToDeerModuleSettingsPage({
          history,
          module: L2_VALUES.review,
          activeTabId: 'review_cycles',
        });
      } else {
        goToModuleSettingsPage({
          history,
          module: MODULE_KEYS1.REVIEW,
          activeTabId: 'review_cycles',
        });
      }
    },
    onError: (error: { body?: { message?: string } }) => {
      const errorMessage = error.body?.message;
      toast({ title: errorMessage, status: 'error' });
    },
  });
};
